import React from 'react';
import ServicePage from '../components/services/ServicePage';
import eventBoards from '../data/services/event-boards';

const EventBoards: React.FC = () => <ServicePage data={eventBoards} />;

export default EventBoards;
